/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

jQuery(document).ready(function($) {
    // Disable the form submission, as it is not needed
    $('.filter-reasonable-filter-bar__form').on('submit', function(e) {
        e.preventDefault();
    });

    // Bind the toggle button to the filter form
    $('.wp-block-filter-reasonable-advanced-search-toggle').on('click', function() {
        $nextForm = $(this).closest('.wp-block-filter-reasonable-filter-bar').next().find('.filter-reasonable-filter-form__form');
        if ($nextForm.length) {
            $nextForm.slideToggle(() => {
                // check if the form is visible
                if ($nextForm.is(':visible')) {
                    $(this).find('span').text($(this).data('hide-label'));
                } else {
                    $(this).find('span').text($(this).data('show-label'));
                }
            });
        } else {
            $(this).closest('.wp-block-filter-reasonable-filter-bar')
                .next()
                .removeClass('d-none')
                .removeClass('d-lg-flex')
                .removeClass('d-lg-block')
                .slideToggle(() => {
                    // check if the form is visible
                    if ($(this).closest('.wp-block-filter-reasonable-filter-bar').next().is(':visible')) {
                        $(this).find('span').text($(this).data('hide-label'));
                    } else {
                        $(this).find('span').text($(this).data('show-label'));
                    }
                });
        }
    }).each(function() {
        const nextItem = $(this).closest('.wp-block-filter-reasonable-filter-bar').next()
        // check if the next item has the class d-none and is not visible
        if (nextItem.hasClass('d-none') && !nextItem.is(':visible')) {
            nextItem.css('display', 'none');
            $(this).find('span').text($(this).data('show-label'));
        } else {
            $(this).find('span').text($(this).data('hide-label'));
        }
    });

    /**
     * Copy the input data from the source input field to the target form input field.
     * @param $srcInput
     * @param $targetForm
     * @param triggerChange
     * @returns {*}
     */
    function copyInputData($srcInput, $targetForm, triggerChange = false) {
        const $srcInputName = $srcInput.attr('name');
        const $srcInputValue = $srcInput.val();
        let $targetInput;

        if ($srcInput.is('select')) {
            $targetInput = $targetForm.find('[name="' + $srcInputName + '"]');

            $targetInput.find('option').removeAttr('selected');
            $targetInput.find('option[value="' + $srcInputValue + '"]').attr('selected', 'selected');
        }
        else if ($srcInput.is('input[type="checkbox"]')) {
            $targetInput = $targetForm.find('[name="' + $srcInputName + '"][value="' + $srcInputValue + '"]');

            if ($srcInput.is(':checked')) {
                $targetInput.prop('checked', true);
            } else {
                $targetInput.prop('checked', false);
            }
        }
        else if ($(this).is('input[type="radio"]')) {
            $targetInput = $targetForm.find('[name="' + $srcInputName + '"]');

            $targetInput.prop('checked', false);
            $targetInput.find('[value="' + $srcInputValue + '"]').prop('checked', true);
        }
        else {
            $targetInput = $targetForm.find('[name="' + $srcInputName + '"]');

            $targetInput.attr('value', $srcInputValue);
        }

        if (triggerChange && $targetInput) {
            $targetInput.trigger('change');
        }
    }

    // $('.filter-reasonable-filter-bar__content input, .filter-reasonable-filter-bar__content select').on('change', function() {
    //     copyInputData($(this), $('.filter-reasonable-filter-form__form'), true);
    // });
    //
    // $('.filter-reasonable-filter-form__form input, .filter-reasonable-filter-form__form select').on('change', function() {
    //     copyInputData($(this), $('.filter-reasonable-filter-bar__content'));
    // });
    //
    // $(".filter-reasonable-filter-form__form").on('reset', () => {
    //     $('.filter-reasonable-filter-bar__content').trigger('reset');
    // });
});